import React from 'react';
import { StateEnum } from 'constants/state';
import { FormInstance } from 'antd';
import {
  Input,
  Select,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  AddressInline,
  NotesInline,
  InlineFormGroup,
} from './style';

export interface AddClientBasicFormData {
  name?: string
  state?: StateEnum
  city?: string
  address?: string
  phone?: string
  email?: string
  cpf?: string
  cnpj?: string
  stateRegistration?: string
  notes?: string
  isActive: boolean
}

interface AddFormProps {
  formHandler: FormInstance
  isLoading?: boolean
}

const AddForm = ({
  formHandler,
  isLoading,
}: AddFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
  >
    <BaseFormItem
      label="Nome"
      name="name"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <AddressInline>
      <BaseFormItem
        label="Cidade"
        name="city"
        className="city-input"
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Estado"
        name="state"
        className="state-input"
        initialValue={StateEnum.AC}
      >
        <Select disabled={isLoading}>
          {Object.values(StateEnum).map((state) => (
            <Select.Option value={state} key={state}>{state}</Select.Option>
          ))}
        </Select>
      </BaseFormItem>
    </AddressInline>
    <BaseFormItem
      label="Endereço"
      name="address"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="Telefone"
      name="phone"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <BaseFormItem
      label="E-mail"
      name="email"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <InlineFormGroup>
      <BaseFormItem
        label="CPF"
        name="cpf"
        className="cpf-input"
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="CNPJ"
        name="cnpj"
        className="cnpj-input"
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
    </InlineFormGroup>
    <BaseFormItem
      label="Inscrição estadual"
      name="stateRegistration"
    >
      <Input disabled={isLoading} />
    </BaseFormItem>
    <NotesInline
      label="Observações"
      name="notes"
    >
      <Input.TextArea disabled={isLoading} rows={5} />
    </NotesInline>
  </FormContainer>
);

AddForm.defaultProps = {
  isLoading: false,
};

export default AddForm;
